import Link from 'next/link'
import styles from './CtaButton.module.scss'
import { useWindowSize } from 'utils/hooks'
import { DynamicIcon } from '~elements'
import { IconNameType } from '~types'
import { CtaButtonProps } from '../../types'

const CtaButton = ({ title, url, iconName: rawIconName, isTargetBlank }: CtaButtonProps) => {
  const iconName: IconNameType = rawIconName ? rawIconName : 'calendar'
  const { isBreakpoint: isBelowMdPlus } = useWindowSize('md-plus', '<')

  return url ? (
    <Link
      className={styles['header-button']}
      href={url}
      {...(isTargetBlank && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <DynamicIcon name={iconName} />
      {!isBelowMdPlus && <span>{title}</span>}
    </Link>
  ) : null
}

export default CtaButton
